import { Component, Input, OnInit } from '@angular/core';
import { FeedbackModel, FeedbackComponent } from '@cibg/ui-components';
import { BaseComponent } from '../../components/base/base.component';
import { TextResourceService } from '../../services/text-resource.service';
import { Suggestion } from '../models/suggestion';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-suggestion',
    templateUrl: './suggestion.component.html',
    imports: [FeedbackComponent, NgClass]
})
export class SuggestionComponent extends BaseComponent implements OnInit {
  @Input() suggestion: Suggestion;

  disclaimerMessages = new FeedbackModel();
  suggestionText: string;

  constructor(private readonly textResourceService: TextResourceService) {
    super(textResourceService, 'SuggestionComponent');
  }

  ngOnInit() {
    this.disclaimerMessages.infoMessages.addMessage(this.resources.suggestionDisclaimer);
    this.disclaimerMessages.infoMessages.isAlertRole = false;
    this.determineResources();
  }

  private determineResources() {
    const textKey = this.suggestion.text;

    this.suggestionText = this.resources[textKey];

    if (this.suggestion.id === 'suggestionUnfortunately') {
      this.textResourceService.getResources('AdvieswijzerComponent')
        .subscribe(r => this.suggestionText += r.moreInfoText);
    }
  }
}
